module.exports = __webpack_public_path__ + "static/media/Icon.e0824dcf.png";